import { useSelector } from 'react-redux';

import { selectProducts } from '@/domains/productDiscovery/Listings/selectors/products';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { Product } from '../../algolia/interfaces/product';
import type { WithSponsoredProduct } from '../sponsoredProducts/interfaces/product';

export const useProducts = <
  P extends Product = Product & WithSponsoredProduct,
>(): P[] => {
  return useSelector<SpartacuxProductDiscoveryDomainState, P[]>(selectProducts);
};
